import React, { useState, useEffect } from 'react';
import { Input} from 'reactstrap';

const TextInput = (props) => {
  const {
    label="",
    initialValue,
    placeholder
  } = props

  const [ value, setValue ] = useState(''); 

  useEffect(() => {
    if (initialValue!==placeholder){
      setValue(initialValue)
    }
  }, [])

  return (
    <>
      <p className='body-copy mb-8'>{label}</p>
      <Input
        className='mb-40'
        onChange={event => setValue(event.target.value)}
        value={value}
        {...props}
      />
    </>
    
  )
}

export default TextInput;

